import { render, staticRenderFns } from "./BundleCouponCreateAndUpdateFormItems.vue?vue&type=template&id=6964ae0c&"
import script from "./BundleCouponCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./BundleCouponCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports